import styled, { css } from 'styled-components'

import { mediaMinTablet } from '@root/shared/ui-kit'

export * from './auth-input'

export const AuthTitle = styled.div`
  color: var(--text-12);
  text-align: center;
  font-size: 26px;
  font-weight: 500;
  line-height: 26px;
  margin-bottom: 14px;

  ${mediaMinTablet(css`
    margin-top: 150px;
    font-size: 24px;
    font-weight: 700;
    color: var(--text-12);
  `)}
`

export const AuthSubTitle = styled.div`
  color: var(--textA-11);
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 20px;

  ${mediaMinTablet(css`
    font-size: 16px;
    color: var(--text-12);
  `)}
`

export const AuthTitleSeparator = styled.div`
  color: var(--text-11);

  text-align: center;
  font-size: 14px;
  font-weight: 500;

  display: grid;
  grid-template-rows: auto 1fr;

  &::after {
    content: '';

    height: 1px;
    width: 100%;
    margin-top: 16px;

    opacity: 0.07;
    background: radial-gradient(
      50% 50% at 50% 50%,
      var(--text-12) 0%,
      var(--text-12) 80%,
      rgba(255, 255, 255, 0) 100%
    );
  }
`
